import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

/**
 * <CreateCategoryDialog onCreateCategory = {item} onCancel = {} />
 */

class CreateCategoryDialog extends Component {

	state = {
		name: "",
	}

	isReadyToCreate() {
		return this.state.name !== ""
	}

	render() {

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Создать категорию
			</DialogTitle>

			<DialogContent style = {{display: "flex", flexDirection: "column"}}>

				<TextField
					value = {this.state.name}
					label = "Название категории"
					margin = "normal"
					onChange = {e => {
						this.setState({
							name: e.target.value
						})
					}}
				/>

			</DialogContent>

			<DialogActions>
			
				<Button
					disabled = {!this.isReadyToCreate()}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCreateCategory === "function") {
							this.props.onCreateCategory({
								name: this.state.name,
							})
						}
					}}
				>Создать</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default CreateCategoryDialog
